import React, { createContext, useContext, useState, useEffect } from "react";
import api from "./api";

const AuthContext = createContext(null);


export function AuthProvider({ children }) {
  const [user, setUser]               = useState(null);
  const [impersonating, setImpersonating] = useState(null); // target user object
  const [loading, setLoading]         = useState(true);

  useEffect(() => {
    const storedUser  = localStorage.getItem("user");
    const storedImp   = localStorage.getItem("impersonating");
    if (storedUser) setUser(JSON.parse(storedUser));
    if (storedImp)  setImpersonating(JSON.parse(storedImp));
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const params = new URLSearchParams();
    params.append("username", email);
    params.append("password", password);
    const { data } = await api.post("/auth/login", params);
    localStorage.setItem("token", data.access_token);
    const me = await api.get("/auth/me");
    localStorage.setItem("user", JSON.stringify(me.data));
    setUser(me.data);
    setImpersonating(null);
    localStorage.removeItem("impersonating");
    localStorage.removeItem("admin_token");
    return me.data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("impersonating");
    localStorage.removeItem("admin_token");
    setUser(null);
    setImpersonating(null);
  };

  const impersonateUser = async (targetUser) => {
    // Save real admin token before switching
    const adminToken = localStorage.getItem("token");
    localStorage.setItem("admin_token", adminToken);

    const { data } = await api.post(`/auth/impersonate/${targetUser.id}`);
    localStorage.setItem("token", data.access_token);

    // The "user" context becomes the impersonated user for UI purposes
    const impersonatedUser = { ...targetUser };
    localStorage.setItem("impersonating", JSON.stringify(impersonatedUser));
    setImpersonating(impersonatedUser);

    // Update user so sidebar/nav reflects impersonated role
    setUser(impersonatedUser);
  };

  const stopImpersonating = async () => {
    const adminToken = localStorage.getItem("admin_token");
    if (!adminToken) { logout(); return; }

    localStorage.setItem("token", adminToken);
    localStorage.removeItem("admin_token");
    localStorage.removeItem("impersonating");
    setImpersonating(null);

    // Reload real admin user info
    const me = await api.get("/auth/me");
    localStorage.setItem("user", JSON.stringify(me.data));
    setUser(me.data);
  };

  return (
    <AuthContext.Provider value={{ user, impersonating, login, logout, impersonateUser, stopImpersonating, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
